<template>
  <v-container fluid class="pt-3">
    <v-card class="elevation-0 shadow-md white mt-2 flex xs12 px-2">
      <v-card-title primary-title class="subheading mx-2 body-2">
        <strong v-if="!readonly">{{ $t("corporate_reg_form") }}: </strong>
        <strong v-else>{{ $t("corporate_details") }}: </strong>

        <v-divider class="mx-2" />
        <!-- <v-spacer /> -->
        <v-btn
          icon
          flat
          v-if="customer.id"
          color="grey darken-2"
          :to="`/print/corporates/${customer.id}`"
        >
          <v-icon>print</v-icon>
        </v-btn>
        <v-btn
          icon
          flat
          color="grey darken-2"
          :to="`/corporates/edit/${customer.id}`"
          v-if="customer.id && readonly && userCan('edit_corporates')"
        >
          <v-icon>edit</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-1">
        <!-- Corporate Detials -->
        <v-layout row wrap>
          <v-flex
            xs12
            class="px-2 di-flex flex-row mb-4 justify-start align-start"
          >
            <!-- <v-checkbox
              :label="$t('temporary')"
              v-model="customer.corporate.temporary"
            /> -->
          </v-flex>
          <v-flex xs12 md5 class="px-2">
            <v-layout row wrap>
              <v-autocomplete
                outline
                placeholder=" "
                :items="states"
                item-value="id"
                :readonly="readonly"
                :label="$t('status')"
                v-model="customer.corporate.temporary"
              />
              <!-- nature_of_busines_types -->
              <!-- :items="['Money Service Provider', 'Foreign exchange dealer', 'Business income']" -->
              <div class="mx-1"></div>
              <v-checkbox
                :label="$t('sanction_screening')"
                v-model="customer.corporate.sanction_screening"
              />
            </v-layout>
            <v-layout row wrap>
              <v-text-field
                outline
                placeholder=" "
                :readonly="readonly"
                v-validate="'required'"
                :label="$t('corporate_name')"
                data-vv-name="corporate_name"
                :data-vv-as="$t('corporate_name')"
                v-model="customer.corporate.corporate_name"
                :error-messages="errors.collect('corporate_name')"
              />
            </v-layout>

            <v-layout row wrap>
              <v-text-field
                outline
                placeholder=" "
                :readonly="readonly"
                v-validate="'required'"
                :label="$t('corporate_name')"
                data-vv-name="corporate_name"
                :data-vv-as="$t('corporate_name')"
                v-model="customer.corporate.corporate_name"
                :error-messages="errors.collect('corporate_name')"
              />
            </v-layout>
            <v-layout row wrap>
              <v-combobox
                outline
                cache-items
                placeholder=" "
                :readonly="readonly"
                :items="customer_types"
                :label="$t('customer_type')"
                v-model="customer.corporate.customer_type"
              />
              <!-- nature_of_busines_types -->
              <!-- :items="['Money Service Provider', 'Foreign exchange dealer', 'Business income']" -->
              <div class="mx-1"></div>
              <v-combobox
                outline
                cache-items
                placeholder=" "
                :readonly="readonly"
                :items="nature_of_busines_types"
                :label="$t('nature_of_business')"
                v-model="customer.corporate.nature_of_business"
              />
            </v-layout>
            <v-layout row wrap>
              <v-text-field
                outline
                placeholder=" "
                :readonly="readonly"
                :label="$t('tin_number')"
                v-model="customer.corporate.tin_number"
              />
              <div class="mx-1"></div>
              <v-textarea
                outline
                rows="0"
                auto-grow
                placeholder=" "
                :readonly="readonly"
                :label="$t('business_address')"
                v-model="customer.corporate.business_address"
              />
            </v-layout>
            <v-layout row wrap>
              <v-date
                :editable="true"
                :has-icon="true"
                format="YYYY-MM-DD"
                input_id="reg_date"
                :readonly="readonly"
                :single-line="false"
                :label="$t('reg_date')"
                value-type="YYYY-MM-DD"
                class="flex xs12 sm6 px-1"
                :placeholder="$t('reg_date')"
                v-model="customer.corporate.reg_date"
              />
              <v-date
                :readonly="readonly"
                format="YYYY-MM-DD"
                value-type="YYYY-MM-DD"
                class="flex xs12 sm6 px-1"
                input_id="incorporation_date"
                :label="$t('incorporation_date')"
                :placeholder="$t('incorporation_date')"
                v-model="customer.corporate.incorporation_date"
              />
            </v-layout>
            <v-layout row>
              <v-text-field
                outline
                placeholder=" "
                :readonly="readonly"
                :label="$t('license_no')"
                v-model="customer.corporate.license_no"
              />
              <div class="mx-1"></div>
              <v-text-field
                outline
                placeholder=" "
                :readonly="readonly"
                :label="$t('reg_name')"
                v-model="customer.corporate.reg_name"
              />
            </v-layout>
            <div class="di-flex">
              <v-date
                class="flex"
                format="YYYY-MM-DD"
                :readonly="readonly"
                value-type="YYYY-MM-DD"
                input_id="license_issue_date"
                :placeholder="$t('license_issue_date')"
                v-model="customer.corporate.license_issue_date"
              />
              <div class="mx-1"></div>
              <v-date
                class="flex"
                :readonly="readonly"
                format="YYYY-MM-DD"
                value-type="YYYY-MM-DD"
                input_id="license_expire_date"
                :placeholder="$t('license_expire_date')"
                v-model="customer.corporate.license_expire_date"
              />
            </div>
          </v-flex>
          <v-flex xs12 md5 class="px-2">
           
             <v-layout row>
              <v-text-field
              outline
              placeholder=" "
              :readonly="readonly"
              :label="$t('source_of_fund')"
              v-model="customer.corporate.source_of_fund"
            />
              <div class="mx-1"></div>
              <v-text-field
                outline
                placeholder=" "
                :readonly="readonly"
                :label="$t('occupation')"
                v-model="customer.corporate.occupation"
              />
            </v-layout>
            <v-layout row>
              <v-text-field
                outline
                placeholder=" "
                :readonly="readonly"
                :label="$t('transactions_count')"
                v-model="customer.corporate.transactions_count"
              />
              <div class="mx-1"></div>
              <v-text-field
                outline
                placeholder=" "
                :readonly="readonly"
                :label="$t('transactions_amount')"
                v-model="customer.corporate.transactions_amount"
              />
            </v-layout>
            <v-layout row>
              <v-text-field
                outline
                placeholder=" "
                :readonly="readonly"
                :label="$t('monthly_income')"
                v-model="customer.corporate.monthly_income"
              />
              <div class="mx-1"></div>
              <v-text-field
                outline
                placeholder=" "
                :readonly="readonly"
                :label="$t('monthly_turnover')"
                v-model="customer.corporate.monthly_turnover"
              />
            </v-layout>
            <v-combobox
              outline
              multiple
              small-chips
              placeholder=" "
              :readonly="readonly"
              :label="$t('company_phones')"
              v-model="customer.corporate.company_phones"
            />
            <v-text-field
              outline
              placeholder=" "
              :readonly="readonly"
              :label="$t('company_email')"
              v-model="customer.corporate.company_email"
            />
            <v-textarea
              outline
              rows="0"
              auto-grow
              placeholder=" "
              :readonly="readonly"
              :label="$t('reg_address')"
              v-model="customer.corporate.reg_address"
            />
          </v-flex>
          <v-divider class="flex xs10 my-4"></v-divider>

          <v-flex xs12 md5 class="px-2">
            <div class="di-flex align-center mb-5 flex xs12">
              <strong class="body-2">{{ $t("kyc_notes") }}</strong>
            </div>
            <div class="di-flex">
              <v-combobox
                outline
                placeholder=" "
                :readonly="readonly"
                :label="$t('risk_profile')"
                :items="['High', 'Medium', 'Low']"
                v-model="customer.corporate.risk_profile"
              />
            </div>
            <v-textarea
              outline
              rows="0"
              auto-grow
              placeholder=" "
              :readonly="readonly"
              :label="$t('kyc_notes')"
              v-model="customer.corporate.kyc_notes"
              :error-messages="errors.collect('kyc_notes')"
            />
            <v-layout row>
              <v-date
                class="flex"
                format="YYYY-MM-DD"
                :readonly="readonly"
                @input="setNextKycDate"
                value-type="YYYY-MM-DD"
                input_id="kyc_updated_date"
                :placeholder="$t('kyc_updated_date')"
                v-model="customer.corporate.kyc_updated_date"
              />
              <div class="mx-1" />
              <v-date
                class="flex"
                format="YYYY-MM-DD"
                :readonly="readonly"
                value-type="YYYY-MM-DD"
                input_id="next_kyc_date"
                :placeholder="$t('next_kyc_date')"
                v-model="customer.corporate.next_kyc_date"
              />
            </v-layout>
            <v-layout row wrap>
              <v-checkbox
                :label="$t('pep')"
                class="flex xs12 md4"
                v-model="customer.corporate.pep"
              />
            </v-layout>
          </v-flex>
          <v-flex xs12 md5 class="px-2">
            <div class="di-flex align-center mb-5">
              <strong class="body-2">{{ $t("contact_details") }}</strong>
            </div>
            <v-layout row>
              <v-text-field
                outline
                placeholder=" "
                :readonly="readonly"
                v-validate="'required'"
                :label="$t('contact_person_name')"
                data-vv-name="contact_person_name"
                :data-vv-as="$t('contact_person_name')"
                v-model="customer.corporate.contact_name"
                :error-messages="errors.collect('contact_person_name')"
              />
              <div class="mx-1" />
              <v-text-field
                outline
                placeholder=" "
                :readonly="readonly"
                :label="$t('designation')"
                v-model="customer.corporate.contact_designation"
              />
            </v-layout>
            <v-combobox
              outline
              multiple
              small-chips
              placeholder=" "
              :readonly="readonly"
              :label="$t('phones')"
              v-model="customer.corporate.contact_phones"
            />
            <v-text-field
              outline
              placeholder=" "
              :readonly="readonly"
              :label="$t('email')"
              v-model="customer.corporate.contact_email"
            />
          </v-flex>
        </v-layout>

        <!-- Directors -->
        <v-layout row wrap class="mt-3">
          <v-divider class="flex xs10 mt-3"></v-divider>
          <v-flex
            xs12
            md5
            class="px-2"
            v-for="(director, i) in customer.directors"
            :key="i"
          >
            <div class="di-flex align-center mt-3 mb-4 flex xs12">
              <v-btn
                icon
                flat
                color="primary"
                @click="addDirector"
                v-if="i == 0 && !readonly"
              >
                <v-icon>add_circle</v-icon>
              </v-btn>
              <v-btn
                icon
                flat
                color="pink"
                @click="removeDirector(i)"
                v-if="i > 0 && !readonly"
              >
                <v-icon>close</v-icon>
              </v-btn>
              <strong class="body-2 mt-1">{{
                `${director.designation}`
              }}</strong>
            </div>
            <customer-image
              :key="i"
              class="mb-5"
              :readonly="readonly"
              v-model="director.image"
            />
            <v-layout row>
              <v-text-field
                outline
                placeholder=" "
                :readonly="readonly"
                :label="$t('name')"
                v-validate="'required'"
                :data-vv-as="$t('name')"
                v-model="director.name"
                :data-vv-name="`${i}_name`"
                :error-messages="errors.collect(i + '_name')"
              />
              <div class="mx-1"></div>
              <v-text-field
                outline
                placeholder=" "
                :readonly="readonly"
                :label="$t('father_name')"
                v-model="director.father_name"
              />
            </v-layout>
            <v-layout row>
              <v-text-field
                outline
                placeholder=" "
                :readonly="readonly"
                v-validate="'required'"
                :label="$t('designation')"
                v-model="director.designation"
                :data-vv-as="$t('designation')"
                :data-vv-name="`${i}_designation`"
                :error-messages="errors.collect(i + '_designation')"
              />
              <div class="mx-1"></div>
              <v-text-field
                outline
                placeholder=" "
                :readonly="readonly"
                :label="$t('occupation')"
                v-model="director.occupation"
              />
              <!-- <v-text-field
                outline
                placeholder=" "
                :readonly="readonly"
                :label="$t('monthly_income')"
                v-model="director.monthly_income"
              /> -->
            </v-layout>

            <v-layout row>
              <v-text-field
                outline
                placeholder=" "
                :readonly="readonly"
                :label="$t('tazkira_no_or_p')"
                v-model="director.tazkira_no"
              />
              <div class="mx-1"></div>
              <v-text-field
                outline
                placeholder=" "
                :readonly="readonly"
                :label="$t('nationality')"
                v-model="director.nationality"
              />
            </v-layout>
            <v-layout row>
              <v-date
                tabi="0"
                class="flex"
                :has-icon="true"
                :readonly="readonly"
                :single-line="false"
                format="YYYY-MM-DD"
                value-type="YYYY-MM-DD"
                :input_id="`${i}_issue`"
                v-model="director.issue_date"
                :placeholder="$t('issue_date')"
              />
              <div class="mx-1" />
              <v-date
                tabi="0"
                class="flex"
                :has-icon="true"
                :readonly="readonly"
                format="YYYY-MM-DD"
                :single-line="false"
                value-type="YYYY-MM-DD"
                :input_id="`${i}_epxi`"
                :placeholder="$t('expire_date')"
                v-model="director.expire_date"
              />
            </v-layout>
            <v-layout row wrap>
              <v-combobox
                outline
                placeholder=" "
                :readonly="readonly"
                :label="$t('gender')"
                v-model="director.gender"
                :items="['Male', 'Female']"
              />
              <div class="mx-1" />
              <v-combobox
                outline
                placeholder=" "
                :readonly="readonly"
                :label="$t('marital_status')"
                :items="['Married', 'Single']"
                v-model="director.marital_status"
              />
            </v-layout>

            <v-layout row wrap>
              <v-textarea
                outline
                rows="0"
                auto-grow
                placeholder=" "
                :readonly="readonly"
                :label="$t('place_of_birth')"
                v-model="director.place_of_birth"
              />
              <div class="mx-1"></div>
              <v-date
                class="flex"
                :input_id="`${i}_brt`"
                :readonly="readonly"
                format="YYYY-MM-DD"
                value-type="YYYY-MM-DD"
                :placeholder="$t('date_of_birth')"
                v-model="director.date_of_birth"
              />
            </v-layout>
            <v-text-field
              outline
              placeholder=" "
              :readonly="readonly"
              :label="$t('share_percentage')"
              v-model="director.share_percentage"
            />
            <v-textarea
              outline
              rows="0"
              auto-grow
              placeholder=" "
              :readonly="readonly"
              :label="$t('current_address')"
              v-model="director.current_address"
            />
            <v-textarea
              outline
              rows="0"
              auto-grow
              placeholder=" "
              :readonly="readonly"
              :label="$t('permanent_address')"
              v-model="director.permanent_address"
            />
            <v-combobox
              multiple
              outline
              small-chips
              placeholder=" "
              :readonly="readonly"
              :label="$t('phones')"
              v-model="director.phones"
            />
            <v-text-field
              outline
              placeholder=" "
              :readonly="readonly"
              :label="$t('email')"
              v-model="director.email"
            />
          </v-flex>
          <v-flex xs12 sm5 mt-1>
            <v-container fluid>
              <v-layout row wrap class="justify-center">
                <v-flex xs12 class="di-flex align-center justify-space-between">
                  <div class="caption">
                    <strong>{{ $t("files") }}</strong>
                    <br />
                    {{ $t("file_max_notation") }}
                  </div>
                  <file-chooser
                    text
                    color="secondary"
                    v-show="!readonly"
                    v-model="customer.files"
                  />
                </v-flex>
                <v-flex xs12 v-if="customer.files.length > 0" class="mt-3">
                  <file-viewer :files="customer.files" />
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>

        <!-- <v-divider class="flex xs12 mb-3"></v-divider> -->
        <v-flex xs12 class="di-flex justify-end">
          <v-btn
            class="mx-0"
            @click="save"
            color="primary"
            v-if="!readonly"
            :loading="loading"
          >
            <v-icon class="mx-2" left>check</v-icon>
            <strong class="mt-1">
              {{ $t("save") }}
            </strong>
          </v-btn>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { customersMixin } from "@/mixins/index.js";
let currentDate = new Date();
currentDate.setFullYear(currentDate.getFullYear() + 1);
export default {
  name: "CorporateCustomerReg",
  props: {
    value: {
      default: () => {
        corporate: {
        }
      },
    },
    readonly: {
      default: false,
    },
  },
  data: () => ({
    loading: false,
    customer_types: [
      "Money Service Provider",
      "Foreign exchange dealer",
      "Exchange and Money Service Co",
      "NGO",
      "Bank",
      "Embassy, Aid Agency",
      "Sole Proprietor business",
      "Business",
    ],
    nature_of_busines_types: [
      "Trading",
      "Manufacturing & Industry",
      "Construction & Building",
      "Services",
      "Health care",
      "Financial Institution",
      "Gov related",
      "Transportation",
      "Tele communication",
    ],
    customer: {
      files: [],
      name: " ",
      is_bank: false,
      type: "corporate",
      corporate: {
        corporate_name: "",
        nature_of_business: "",
        business_address: "",
        tin_number: "",
        incorporation_date: null,
        license_issue_date: null,
        license_expire_date: null,
        monthly_income: null,
        monthly_turnover: null,
        company_phones: null,
        company_email: null,
        reg_name: null,
        license_no: null,
        reg_address: null,
        risk_profile: null,
        kyc_notes: null,
        reg_date: new Date().toLocaleDateString("en-ca"),
        kyc_updated_date: new Date().toLocaleDateString("en-ca"),
        next_kyc_date:  currentDate.toLocaleDateString("en-ca"),
        name: null,
        designation: null,
        phones: null,
        email: null,
        temporary:0,//permanent
        sanction_screening: false,
        is_pep: false,
      },
      directors: [
        {
          id: null,
          name: null,
          father_name: null,
          designation: null,
          monthly_income: null,
          tazkira_no: null,
          nationality: null,
          place_of_birth: null,
          gender: "male",
          photo: require("@/assets/images/userplaceholder.svg"),
          image: require("@/assets/images/userplaceholder.svg"),
          marital_status: "single",
          date_of_birth: null,
          current_address: null,
          permanent_address: null,
          phones: null,
          email: null,
        },
      ],
    },
  }),
  mixins: [customersMixin],
  computed: {
    isTazkira() {
      return this.customer.corporate.doctype == "tazkira";
    },
    fullName() {
      let details = this.customer.corporate;
      return (
        details.first_name + " " + details.middle_name + " " + details.last_name
      );
    },
    showDelete() {
      return this.customer.directors.length > 1;
    },
    states() {
      return [
        { id: 1, text: this.$t("temporary") },
        { id: 0, text: this.$t("permanent") },
      ];
    },
  },
  methods: {
    setNextKycDate() {
      let currentDate = new Date(this.customer.corporate.kyc_updated_date);
      currentDate.setFullYear(currentDate.getFullYear() + 1);
      this.customer.corporate.next_kyc_date = currentDate
        .toLocaleDateString("en-ca");
    },
    save() {
      this.loading = true;
      this.$validator.validateAll().then((succeed) => {
        if (succeed) {
          this.customer.name = this.customer.corporate.corporate_name;
          this.axios
            .post("customers", this.customer)
            .then(async (res) => {
              let filesToUpload = this.customer.files.filter((x) => !x.id);
              if (filesToUpload.length > 0) {
                const fd = new FormData();

                fd.append("fileable_type", "Customer");
                fd.append("fileable_id", res.data.data.id);

                for (const file of filesToUpload) {
                  fd.append("files[]", file);
                }

                await this.axios.post("files", fd, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                });
              }
              this.loading = false;
              this.customer.id = res.data.data.id;
              this.$store.commit("showSnackbar", {
                text: this.$t("save_succeed"),
                stateType: "success",
                show: true,
              });

              this.$router.replace(`/print/corporates/${res.data.data.id}`);
              this.getCustomers();
              this.$emit("saved", res.data.data);
            })
            .catch((e) => {
              console.log(e);
              this.loading = false;
            });
        } else {
          this.loading = false;
          this.$store.commit("showSnackbar", {
            text: this.$t("wrong_input"),
            stateType: "error",
            show: true,
          });
        }
      });
    },

    addDirector() {
      this.customer.directors.push({
        name: "",
        father_name: "",
        designation: "",
        monthly_income: "",
        tazkira_no: "",
        nationality: "",
        place_of_birth: "",
        date_of_birth: "",
        current_address: "",
        permanent_address: "",
        photo: require("@/assets/images/userplaceholder.svg"),
        image: require("@/assets/images/userplaceholder.svg"),
        phones: [],
        email: "",
      });
    },
    removeDirector(index) {
      this.customer.directors.splice(index, 1);
    },
  },
  watch: {
    value: function () {
      this.customer = this.value;
      this.$emit("input", this.value);
    },
  },
  created() {
    let id = this.$store.state.route.params.id;
    if (this.readonly) {
      this.customer = this.value;
    } else if (id) {
      this.axios
        .get(`customers/${id}?type=corporate`)
        .then((response) => {
          this.customer = response.data.data;
          this.correct_route = true;
          this.loading = false;
        })
        .catch((error) => {
          this.correct_route = false;
          this.loading = false;
        });
    }
  },
};
</script>
<style >
.reg_customer_image {
  width: 150px !important;
  height: 200px !important;
  background-color: #e2e2e2;
  border: 1px solid #a0a0a0 !important;
}
</style>